import styled from "styled-components";
import { media } from "../../../../../../styles/Qtheme";
import { motion } from "framer-motion";

interface IsActiveProps {
  isActive: boolean;
  activeMenu?: string | null;
  isDefault?: boolean;
}

export const FooterMenuLi = styled.li`
	div {
		display: flex;
		justify-content: space-between;
		align-items: center;
		a {
			display: block;
			width: 100%;
			font-size: 16px;
			font-weight: 600;
			line-height: 19.09px;
			color: ${({ theme }) => theme.text};
        font-family: "Pretendard", sans-serif;

			@media ${media.desktop} {
				margin-bottom: 0;
			}
		}
		margin-bottom: 16px;
	}
`

export const FooterSubMenuUl = styled(motion.ul)<IsActiveProps>`
	display: flex;
	flex-direction: column;
	gap: 8px;

	@media ${media.desktop} {
		padding-left: 16px;
	}

	li {
        transition: all 0.3s;
		a {
			font-size: 16px;
			font-weight: 400;
			line-height: 19.09px;
			color: ${({theme}) => theme.footerText};
			display: block;
			width: 100%;
        font-family: "Pretendard", sans-serif;
		}
	}
	li:hover {
		a {
			color: ${({ theme }) => theme.primary};
		}
	}
`
